t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <ApproveInput
        :question="$t('alarm.question')"
        :image="require('@/assets/alarm.svg')"
        :selected-value="alarmSystem"
        :clicked-callback="onSelect"
      ></ApproveInput>
      <a @click="$router.push(getPrevStepUrl(step))" class="back-btn"
        >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ApproveInput from "../../components/ApproveInput";
import CalculatorHeading from "../../components/CalculatorHeading";
import { getStepIndex, redirectToUnselectedStepIfAny, getPrevStepUrl, getNextStepUrl } from "@/utils/steps.js";

export default {
  name: "VoiceControl",
  components: { CalculatorHeading, ApproveInput },
  data() {
    return {
      step: getStepIndex("alarm"),
      getPrevStepUrl: getPrevStepUrl,
      alarmSystem: this.$store.state.data.alarmSystem
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateAlarmSystem"]),
    onSelect(value) {
      this.alarmSystem = value;
      this.updateAlarmSystem(value);
      setTimeout(() => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)), 200);
    }
  }
};
</script>
